import React from "react";
import { useSelector } from "react-redux";
import translations from "../assets/locals/translations";
import EnquiryCharts from "./EnquiryCharts";
import SalesCharts from "./SalesCharts";
import KpiCard from "./KpiCard";
import ChartCard from "./ChartCard";
import Header from "./Header";
import RecentActivity from "./RecentActivity";
import "../styles/alldashboard.css";

// Import Icons (Make sure @heroicons/react is installed)
import {
  ChartBarIcon,
  CurrencyDollarIcon,
  UserGroupIcon,
  CheckCircleIcon,
  ClockIcon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/solid"; // Or /solid

// No specific CSS import needed here if imported globally in index.js/App.js

const Dashboard = () => {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations["en"];
  // Example KPI Data (Replace with dynamic data)
  const kpiData = [
    {
      title: t.monthlyEnquiries,
      value: "1,280",
      icon: <ChartBarIcon />, // No className needed on icon itself here
      change: "+15%",
      changeType: "positive",
      modifier: "enquiries", // Used for icon color styling
    },
    {
      title: t.monthlyBookings,
      value: "350",
      icon: <CheckCircleIcon />,
      change: "+8%",
      changeType: "positive",
      modifier: "bookings",
    },
    {
      title: t.conversionRate,
      value: "27.3%",
      icon: <ArrowTrendingUpIcon />,
      change: "+1.2%",
      changeType: "positive",
      modifier: "conversion",
    },
    {
      title: t.totalRevenue,
      value: "$45,670",
      icon: <CurrencyDollarIcon />,
      change: "-2%",
      changeType: "negative",
      modifier: "revenue",
    },
  ];

  return (
    <div className="dashboard-container">
      <Header title={t.dashboard} />

      <div className="kpi-grid">
        {kpiData.map((kpi, index) => (
          <KpiCard
            key={index}
            title={kpi.title}
            value={kpi.value}
            icon={kpi.icon}
            change={kpi.change}
            changeType={kpi.changeType}
            modifierClass={kpi.modifier} // Pass modifier for CSS
          />
        ))}
      </div>

      <div className="main-grid">
        {/* Add class for grid spanning */}
        <div className="chart-area--enquiries">
          <ChartCard title={t.enquiryBookingTrends}>
            <EnquiryCharts />
          </ChartCard>
        </div>

        <ChartCard title={t.salesDistributionMonthly}>
          <SalesCharts />
        </ChartCard>

        {/* Add class for grid spanning */}
        <div className="activity-area">
          <RecentActivity />
        </div>

        {/* Example Quick Links Card */}
        <div className="quick-links-card">
          <h3>{t.quickLinks}</h3>
          <ul>
            <li>{t.addNewLead}</li>
            <li>{t.viewAllContacts}</li>
            <li>{t.createReport}</li>
            <li>{t.settings}</li>
          </ul>
        </div>
      </div>

      {/* <footer className="dashboard-footer">
        © {new Date().getFullYear()} Balkrushna Technologies PVT LTD. All rights reserved.
      </footer> */}
    </div>
  );
};

export default Dashboard;
